const initialState = {
	loading: false,
	parking_codes: [],
    locked: []
}

const checkIns = (state = initialState, action) => {
	switch (action.type) {

        
        case 'SET_PARKING_CODES': {
			return {
				...state,
				parking_codes: action.payload.parking_codes || action.payload.codes,
			}
		}

        case 'UPDATE_PARKING_CODE': {

            return {
                ...state,
                parking_codes: state.parking_codes.map((code) => {
                    if (code._id === action.payload._id) {
                        return action.payload
                    }
                    return code
                })
            }
        }
		
		default:
			return state
	}
}

export default checkIns